module.exports = __webpack_public_path__ + "static/media/kwanzaa.7b780964.JPG";